var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:3.71px;font-family:Arial-Black, Arial Black;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Time Off Icon_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5,2.19a6.4,6.4,0,1,0,6.4,6.4A6.4,6.4,0,0,0,7.5,2.19Zm0,11.57a5.15,5.15,0,1,1,5.15-5.15A5.15,5.15,0,0,1,7.49,13.76Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.59,
    y: 0.36,
    width: 1.83,
    height: 2.74,
    rx: 0.2,
    ry: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.18,
    y: 2.52,
    width: 0.6,
    height: 1.77,
    rx: 0.09,
    ry: 0.09
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.18,
    y: 13.07,
    width: 0.6,
    height: 1.77,
    rx: 0.09,
    ry: 0.09
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.38,
    y: 7.72,
    width: 0.6,
    height: 1.77,
    rx: 0.09,
    ry: 0.09,
    transform: "translate(21.29 -4.07) rotate(90)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1.83,
    y: 8.02,
    width: 0.6,
    height: 1.77,
    rx: 0.09,
    ry: 0.09,
    transform: "translate(11.04 6.77) rotate(90)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 3.47,
    y: 4.16,
    width: 0.6,
    height: 1.77,
    rx: 0.09,
    ry: 0.09,
    transform: "translate(10 5.95) rotate(135)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10.89,
    y: 11.58,
    width: 0.6,
    height: 1.77,
    rx: 0.09,
    ry: 0.09,
    transform: "translate(27.92 13.37) rotate(135)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3.47,
    y: 11.44,
    width: 0.6,
    height: 1.77,
    rx: 0.09,
    ry: 0.09,
    transform: "translate(9.82 0.95) rotate(45)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 10.89,
    y: 4.16,
    width: 0.6,
    height: 1.77,
    rx: 0.09,
    ry: 0.09,
    transform: "translate(6.84 -6.44) rotate(45)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 9.83,
    y: 2.23,
    width: 1.83,
    height: 1.48,
    rx: 0.15,
    ry: 0.15,
    transform: "matrix(0.87, 0.5, -0.5, 0.87, 2.92, -4.98)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 6.9,
    y: -1.23,
    width: 1.21,
    height: 3.66,
    rx: 0.19,
    ry: 0.19,
    transform: "translate(8.1 -6.9) rotate(90)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(3.45 10.03)"
  }, "OFF")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeoff);
export default __webpack_public_path__ + "static/media/timeoff.73104ac5faae34fb053f758244262d92.svg";
export { ForwardRef as ReactComponent };